import { render } from "./EditorComponent.vue?vue&type=template&id=251ef7c3"
import script from "./EditorComponent.vue?vue&type=script&lang=js"
export * from "./EditorComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue\\evangelio-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__